module.exports = "/static/assets/5e8eccd5a576638f029a1ed2deb4784b.svg";